function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

/* eslint-disable camelcase */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useUrlParams, Dropdown, DateTimePicker, RangePicker, useUser } from 'components';
import { dateFormat } from 'enums';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var filterField = {
  flex: '1 1 180px',
  maxWidth: 240,
  minWidth: 140
};
var start = '2024-12-01';
var totalMonths = Math.ceil(moment().diff('2024-12-01', 'months', true));

var yearsMonthsOptions = _toConsumableArray(Array(totalMonths)).map(function (_, index) {
  var yearMonth = moment(start).add(index, 'M').format('MM/YYYY');
  return {
    label: "".concat(yearMonth),
    value: "".concat(yearMonth)
  };
});

var GivenPaymentsTableHeader = function GivenPaymentsTableHeader(_ref) {
  var getData = _ref.getData,
      franchisesList = _ref.franchisesList,
      showDateFilter = _ref.showDateFilter,
      showStartEndDateFilter = _ref.showStartEndDateFilter,
      showYearMonthFilter = _ref.showYearMonthFilter;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var office = urlQueryParams.office,
      franchisee = urlQueryParams.franchisee,
      startDateOnly = urlQueryParams.startDateOnly,
      startDate = urlQueryParams.startDate,
      endDate = urlQueryParams.endDate,
      year = urlQueryParams.year,
      month = urlQueryParams.month;
  var queryParams = useRef(urlQueryParams);
  var initialized = useRef(false);
  useEffect(function () {
    if (!initialized.current) {
      initialized.current = true;
      getData(queryParams.current);
    }
  });

  var handleOfficeChange = function handleOfficeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      office: value
    });
    getData(queryParams.current);
  };

  var handleFranchiseeChange = function handleFranchiseeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      franchisee: value
    });
    getData(queryParams.current);
  };

  var handleDateChange = function handleDateChange(value) {
    var date = moment(value).format(dateFormat);
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      startDateOnly: date
    });
    getData(queryParams.current);
  };

  var handleStartEndDateChange = function handleStartEndDateChange(_ref2) {
    var startDate = _ref2.startDate,
        endDate = _ref2.endDate;
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      startDate: startDate,
      endDate: endDate
    });
    getData(queryParams.current);
  };

  var handleYearsMonthsChange = function handleYearsMonthsChange(value) {
    var year = value && moment(value, 'MM/YYYY').format('YYYY');
    var month = value && moment(value, 'MM/YYYY').format('MM');
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      year: year,
      month: month
    });
    getData(queryParams.current);
  };

  return ___EmotionJSX("section", {
    css: tableHeaderContainer
  }, ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041A\u0440. \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A",
    displayKey: "name",
    uniqueKey: "id",
    value: franchisee,
    options: franchisesList,
    onChange: handleFranchiseeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041E\u0444\u0438\u0441",
    displayKey: "name",
    uniqueKey: "id",
    value: office,
    options: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices,
    onChange: handleOfficeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), showDateFilter && ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(DateTimePicker, {
    inputProps: {
      placeholder: 'Начална дата'
    },
    dateFormat: dateFormat,
    timeFormat: false,
    value: startDateOnly,
    onChange: handleDateChange,
    small: true
  })), showStartEndDateFilter && ___EmotionJSX("div", {
    style: {
      flex: '0 0 auto'
    }
  }, ___EmotionJSX(RangePicker, {
    startDatePlaceholderText: "\u041E\u0442 \u0434\u0430\u0442\u0430",
    endDatePlaceholderText: "\u0414\u043E \u0434\u0430\u0442\u0430",
    startDate: startDate,
    endDate: endDate,
    onChange: handleStartEndDateChange
  })), showYearMonthFilter && ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    withSearch: true,
    small: true,
    placeholder: "\u041C\u0435\u0441\u0435\u0446/\u0413\u043E\u0434\u0438\u043D\u0430",
    value: year && month && "".concat(month, "/").concat(year),
    options: yearsMonthsOptions,
    onChange: handleYearsMonthsChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })));
};

GivenPaymentsTableHeader.propTypes = {
  getData: PropTypes.func,
  franchisesList: PropTypes.array,
  showDateFilter: PropTypes.bool,
  showStartEndDateFilter: PropTypes.bool,
  showYearMonthFilter: PropTypes.bool
};
export default GivenPaymentsTableHeader;